import { createSlice } from "@reduxjs/toolkit";

const configSlice = createSlice({
  name: "config",
  initialState: {
    currentStore: null,
  },
  reducers: {
    updateCurrentStore(state, action) {
      state.currentStore = action.payload;
    },
  },
});

export const { updateCurrentStore } = configSlice.actions;
export default configSlice.reducer;
